import { BriefClassificationResponse } from '../../api';
import { Step } from '../../constants';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { PostAndPollAdditionalDataParams, usePostAndPollAdditionalData } from './usePostAndPollAdditionalData';

export const useExtractAdditionalData = () => {
    const { isLoading, postAndPollAdditionalData } = usePostAndPollAdditionalData();
    const { setStep } = useBriefCreationContext();

    const extractAdditionalData = async ({
        leafClassification,
        userInput,
        contextId,
        abortController,
        flowRetries = 0,
        requestType,
    }: Pick<
        PostAndPollAdditionalDataParams,
        'abortController' | 'contextId' | 'userInput' | 'leafClassification' | 'flowRetries' | 'requestType'
    >): Promise<BriefClassificationResponse | undefined> => {
        if (!leafClassification) {
            return;
        }

        // Switch to the loading step while fetching additional classification data
        setStep(Step.Loading);
        return postAndPollAdditionalData({
            requestType,
            leafClassification,
            userInput,
            contextId,
            extractors: ['METADATA', 'BUDGET', 'DELIVERY_TIME'],
            abortController,
            flowRetries,
        });
    };

    return {
        isLoading,
        extractAdditionalData,
    };
};
